import { IStatus } from "../IWebsiteDataV3";
import { HealthStatus } from "./HealthStatus";
import { StatusMessage } from "./StatusMessage";
import { IStatusType } from "./StatusPopoverPicker";

export const HealthStatusAndMessage: React.FC<{ statusType: IStatusType; status: IStatus; message: string; onChange: (changed: {status: IStatus; message: string; }) => void; }> = ({ status, message, onChange, statusType }) => {
    return (
        <>
            <HealthStatus
                statusType={statusType}
                status={status}
                onChange={status => {
                    onChange({ status, message });
                }}
            />
            <StatusMessage
                status={status}
                message={message}
                onChange={message => {
                    onChange({ status, message });
                }}
            />
        </>
    )
}
